export function shortenDurationString(duration: string): string {
  return duration
    .replace(/and/gi, '')
    .replace(/hours?/gi, 'H')
    .replace(/minutes?/gi, 'MIN')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();
}
